import React, { useContext, useEffect, useRef, useState } from "react";
import {
    Stepper,
    Step,
    StepLabel,
    Button,
    Box,
    Typography,
    TextField,
    MenuItem,
    Select,
    FormControl,
    InputLabel,
    FormGroup,
    FormControlLabel,
    RadioGroup,
    Radio,
    Card,
    CardContent,
    useMediaQuery,
    Grid,
    Dialog,
    DialogContent,
    DialogActions,
    IconButton,
    FormLabel,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    styled,
    FormHelperText,
} from "@mui/material";
import { InsertDriveFile as DefaultFileIcon, Image as ImageIcon, PictureAsPdf as PdfIcon } from "@mui/icons-material";
import { useTheme } from "@emotion/react";
import { AddCircle, CloseSquare, DocumentPrevious, TickCircle } from "iconsax-react";
import MedicalRequestHistory from "../medical-request-history/medical-request-history";
import "./medical-tourism-multi-step-form.scss";
import { motion, AnimatePresence } from "framer-motion";
import BASE_URL from "../../../constants/baseUrls";
import { useForm, Controller } from "react-hook-form";
// import LoginModal from "../../common/login-modal/login-modal";
import { useSearchParams } from "react-router-dom";
import { t } from "i18next";
import { Trans } from "react-i18next";
import { LocaleContext } from "../../../routing/LangRouter";
import { toast } from "react-toastify";

//Animate form transition
const pageVariantsForward = {
    initial: { opacity: 0, x: "100%" },
    in: { opacity: 1, x: 0 },
    out: { opacity: 0, x: "-100%" },
};

const pageVariantsBackward = {
    initial: { opacity: 0, x: "-100%" },
    in: { opacity: 1, x: 0 },
    out: { opacity: 0, x: "100%" },
};

const pageTransition = {
    type: "just",
    duration: 0.2,
};
const MotionBox = motion(Box);

const getFileIcon = fileName => {
    const extension = fileName.split(".").pop().toLowerCase();
    switch (extension) {
        case "jpg":
        case "jpeg":
        case "png":
            return <ImageIcon color="success" />;
        case "pdf":
            return <PdfIcon color="error" />;
        default:
            return <DefaultFileIcon color="action" />;
    }
};

const steps = [t("personalInfo"), t("medicalInfo"), t("travelInfo"), t("contactInfo"), t("submitRequest")];
const stepKeys = ["personalInfo", "medicalInfo", "travelInfo", "contactInfo", "submitRequest"];

const genderMap = {
    [t("male")]: 1,
    [t("female")]: 2,
    [t("notSpecified")]: 3,
};
const MedicalTourismMultiStepForm = () => {
    const accessToken = localStorage.getItem("accessToken");
    const [countries, setCountries] = useState([]);
    const [cities, setCities] = useState([]);
    const [activeStep, setActiveStep] = useState(0);
    const [prevActiveStep, setPrevActiveStep] = useState(0);
    const [showSuccess, setShowSuccess] = useState(false);
    const [showHistory, setShowHistory] = useState(false);
    const [isValid, setIsValid] = useState(true);
    // const [openLogin, setOpenLogin] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const { locale } = useContext(LocaleContext);

    const formContentRef = useRef(null);

    const fetchCountries = async () => {
        try {
            const response = await fetch(`${BASE_URL}/api/v2/basic/countries/`);
            const data = await response.json();
            if (data.message === "Success") {
                setCountries(data.data.list);
            }
        } catch (error) {
            // console.error("Error fetching countries:", error);
        }
    };

    const fetchCities = async () => {
        try {
            const response = await fetch(`${BASE_URL}/api/v2/basic/cities/?capitals=1`);
            const data = await response.json();

            if (data.message === "Success") {
                setCities(data.data.results);
            }
            console.log("cities", data.data.results);
        } catch (error) {
            // console.error("Error fetching cities:", error);
        }
    };

    useEffect(() => {
        fetchCountries();
        fetchCities();
    }, []);

    // State to handle form inputs
    const [formValues, setFormValues] = useState({
        first_name: "",
        last_name: "",
        gender: "",
        age: "",
        origin_country_id: "",
        services: [],
        illness_description: "",
        estimated_trip_time: "",
        destination_city_id: "",
        files: [],
        prefer_residence: false,
        prefer_hotel: false,
        preferred_hotel_star_list: [],
        preferred_flight_class_list: [],
        preferred_with_breakfast: false,
        preferred_with_dinner: false,
        preferred_with_lunch: false,
        preferred_with_airport_transfer: false,
        mobile_phone: "",
        email: "",
        telegram: "",
        facebook: "",
        whatsapp: "",
    });
    const {
        control,
        // handleSubmit,
        formState: { errors },
        trigger,
        getValues,
        setValue,
        reset,
        watch,
    } = useForm({
        defaultValues: {
            first_name: "",
            last_name: "",
            gender: "",
            age: "",
            origin_country_id: "",
            services: [],
            illness_description: "",
            estimated_trip_time: "",
            destination_city_id: "",
            preferred_hotel_star_list: [],
            preferred_flight_class_list: [],
            preferred_with_breakfast: false,
            preferred_with_dinner: false,
            preferred_with_lunch: false,
            preferred_with_airport_transfer: false,
            mobile_phone: "",
            email: "",
            telegram: "",
            facebook: "",
            whatsapp: "",
        },
        mode: "onChange",
    });
    // const onSubmit = data => {
    //     setFormValues(prevValues => ({
    //         ...prevValues,
    //         ...data,
    //     }));
    //     return true; // Return true to indicate successful submission
    // };

    const isStepValid = () => {
        const formValues = getValues(); // Get current form values

        if (activeStep === 0) {
            const step0Fields = ["first_name", "last_name", "gender", "age", "origin_country_id"];
            return step0Fields.every(field => formValues[field] && formValues[field].toString().trim() !== "");
        }
        if (activeStep === 1) {
            const step1Fields = ["services", "illness_description", "estimated_trip_time", "destination_city_id"];
            return step1Fields.every(field => {
                if (field === "services") {
                    return formValues[field] && formValues[field].length > 0;
                }
                return formValues[field] && formValues[field].toString().trim() !== "";
            });
        }
        if (activeStep === 2) {
            // Check flight options
            const flightValid =
                flightOption === t("noTicket") ||
                (flightOption === t("flight") && formValues.preferred_flight_class_list && formValues.preferred_flight_class_list.length > 0);

            // Check residency options
            const residencyValid =
                residencyOption === t("noHotel") ||
                residencyOption === t("otherAccomdation") ||
                (residencyOption === t("hotel") && formValues.preferred_hotel_star_list && formValues.preferred_hotel_star_list.length > 0);

            // Check if at least one travel service is selected
            const travelServicesValid =
                formValues.preferred_with_breakfast ||
                formValues.preferred_with_lunch ||
                formValues.preferred_with_dinner ||
                formValues.preferred_with_airport_transfer;

            return flightValid && residencyValid && travelServicesValid;
        }
        if (activeStep === 3) {
            return formValues.mobile_phone && formValues.mobile_phone.trim() !== "";
        }
        return true;
    };

    // Update form values on input change
    const handleInputChange = (field, value) => {
        if (field === "files") {
            if (value && value.length > 0) {
                const allowedExtensions = ["jpg", "png", "pdf"];
                const files = Array.from(value).filter(file => {
                    const fileExtension = file.name.split(".").pop().toLowerCase();
                    if (allowedExtensions.includes(fileExtension)) {
                        return true;
                    } else {
                        toast.error(t("onlyAcceptedFiles"));
                        return false;
                    }
                });
                setFormValues(prevValues => ({
                    ...prevValues,
                    [field]: files,
                }));
            } else {
                // If no file is selected, just keep the previous value (which might be an empty array)
                setFormValues(prevValues => ({
                    ...prevValues,
                    [field]: prevValues[field] || [],
                }));
            }
        } else {
            setFormValues(prevValues => ({
                ...prevValues,
                [field]: value,
            }));
        }
    };

    const handlePreferedHotelStarListCheckboxChange = option => {
        setFormValues(prevValues => {
            const selected = prevValues.preferred_hotel_star_list.includes(option)
                ? prevValues.preferred_hotel_star_list.filter(item => item !== option)
                : [...prevValues.preferred_hotel_star_list, option];

            // Update React Hook Form state
            setValue("preferred_hotel_star_list", selected);
            setValue("prefer_hotel", selected.length > 0);

            return {
                ...prevValues,
                prefer_hotel: selected.length > 0,
                preferred_hotel_star_list: selected,
            };
        });
    };
    const handlePreferedFlightClassListCheckboxChange = option => {
        setFormValues(prevValues => {
            const currentList = prevValues.preferred_flight_class_list;
            const updatedList = currentList.includes(option) ? currentList.filter(item => item !== option) : [...currentList, option];

            setValue("preferred_flight_class_list", updatedList);

            return {
                ...prevValues,
                preferred_flight_class_list: updatedList,
            };
        });
    };

    // breakpoint
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
    // const handleNext = async () => {
    //     // console.log("handleNext called, activeStep:", activeStep);
    //     if (activeStep === steps.length - 2) {
    //         if (!!accessToken) {
    //             try {
    //                 const formDataToSend = new FormData();
    //                 const currentFormValues = getValues();

    //                 const combinedFormValues = {
    //                     ...formValues,
    //                     ...currentFormValues,
    //                     preferred_flight_class_list: currentFormValues.preferred_flight_class_list || [],
    //                     preferred_hotel_star_list: currentFormValues.preferred_hotel_star_list || [],
    //                     files: formValues.files || [], // Ensure files is always included
    //                 };

    //                 Object.entries(combinedFormValues).forEach(([key, value]) => {
    //                     if (value === null || key === "flightOption" || key === "residencyOption") {
    //                         return;
    //                     }

    //                     if (Array.isArray(value)) {
    //                         if (value.length === 0) {
    //                             formDataToSend.append(key, "");
    //                         } else {
    //                             value.forEach(item => {
    //                                 formDataToSend.append(key, item);
    //                             });
    //                         }
    //                     } else if (typeof value === "boolean") {
    //                         formDataToSend.append(key, value.toString());
    //                     } else {
    //                         formDataToSend.append(key, value);
    //                     }
    //                 });

    //                 // Special handling for gender (using genderMap)
    //                 formDataToSend.set("gender", (genderMap[formValues.gender] || 3).toString());

    //                 // Handle file upload
    //                 // if (combinedFormValues.files.length > 0) {
    //                 //     combinedFormValues.files.forEach(file => {
    //                 //         formDataToSend.append("files", file);
    //                 //     });
    //                 // } else {
    //                 //     // If no files are uploaded, append an empty array or a placeholder file
    //                 //     formDataToSend.append("files", JSON.stringify([]));
    //                 // }

    //                 // console.log("formDataToSend", formDataToSend);

    //                 // Send POST request to the API
    //                 const response = await fetch(`${BASE_URL}/api/v2/itinerary/health/tour/request/`, {
    //                     method: "POST",
    //                     headers: {
    //                         Authorization: `Bearer ${accessToken}`,
    //                     },
    //                     body: formDataToSend,
    //                 });

    //                 // Check if the response is ok
    //                 if (!response.ok) {
    //                     // throw new Error(`HTTP error status: ${response.detail}`);
    //                     console.log(response.status);
    //                 }

    //                 // If the request was successful, show success message and move to the final step
    //                 setShowSuccess(true);
    //                 setPrevActiveStep(activeStep);
    //                 setActiveStep(prevActiveStep => prevActiveStep + 1);
    //             } catch (error) {
    //                 if (error.response.status === 401) {
    //                     localStorage.clear();
    //                     setSearchParams({ action: "login" });
    //                 } else console.error("Error submitting form:", error);
    //             }
    //         } else setSearchParams({ action: "login" });
    //     } else {
    //         // console.log("Navigating to next step (not form step)");
    //         setPrevActiveStep(activeStep);
    //         setActiveStep(prevActiveStep => prevActiveStep + 1);
    //     }
    // };

    // useEffect(() => {
    //     if (searchParams.get("action") === "login") setOpenLogin(true);
    //     else setOpenLogin(false);
    // }, [searchParams]);
    const handleNext = async () => {
        if (activeStep === steps.length - 2) {
            if (!!accessToken) {
                try {
                    const formDataToSend = new FormData();
                    const currentFormValues = getValues();

                    const combinedFormValues = {
                        ...formValues,
                        ...currentFormValues,
                        preferred_flight_class_list: currentFormValues.preferred_flight_class_list || [],
                        preferred_hotel_star_list: currentFormValues.preferred_hotel_star_list || [],
                    };

                    Object.entries(combinedFormValues).forEach(([key, value]) => {
                        if (value === null || key === "flightOption" || key === "residencyOption") {
                            return;
                        }

                        if (Array.isArray(value)) {
                            if (value.length === 0 && key !== "files") {
                                formDataToSend.append(key, "");
                            } else {
                                value.forEach(item => {
                                    formDataToSend.append(key, item);
                                });
                            }
                        } else if (typeof value === "boolean") {
                            formDataToSend.append(key, value.toString());
                        } else {
                            formDataToSend.append(key, value);
                        }
                    });

                    // Special handling for gender (using genderMap)
                    formDataToSend.set("gender", (genderMap[formValues.gender] || 3).toString());

                    // Handle file upload only if files are present
                    if (formValues.files && formValues.files.length > 0) {
                        formValues.files.forEach(file => {
                            formDataToSend.append("files", file);
                        });
                    }

                    // Send POST request to the API
                    const response = await fetch(`${BASE_URL}/api/v2/itinerary/health/tour/request/`, {
                        method: "POST",
                        headers: {
                            Authorization: `Bearer ${accessToken}`,
                        },
                        body: formDataToSend,
                    });

                    // Check if the response is ok
                    if (!response.ok) {
                        console.log(response.status);
                    }

                    // If the request was successful, show success message and move to the final step
                    setShowSuccess(true);
                    setPrevActiveStep(activeStep);
                    setActiveStep(prevActiveStep => prevActiveStep + 1);
                } catch (error) {
                    if (error.response && error.response.status === 401) {
                        localStorage.clear();
                        setSearchParams({ action: "login" });
                    } else {
                        console.error("Error submitting form:", error);
                    }
                }
            } else {
                setSearchParams({ action: "login" });
            }
        } else {
            setPrevActiveStep(activeStep);
            setActiveStep(prevActiveStep => prevActiveStep + 1);
        }
    };
    const handleBack = () => {
        setPrevActiveStep(activeStep);
        setActiveStep(prevActiveStep => prevActiveStep - 1);
    };

    const handleCloseRequestHistoryModal = () => {
        setShowHistory(false);
    };
    const handleRemoveFile = index => {
        setFormValues(prevValues => {
            const updatedFiles = [...prevValues.files];
            updatedFiles.splice(index, 1);
            return {
                ...prevValues,
                files: updatedFiles,
            };
        });
    };

    const [flightOption, setFlightOption] = useState("");
    const [residencyOption, setResidencyOption] = useState("");

    const [tripPreferences, setTripPreferences] = useState({
        preferred_with_breakfast: false,
        preferred_with_dinner: false,
        preferred_with_lunch: false,
        preferred_with_airport_transfer: false,
    });

    const handleFlightOptionChange = event => {
        const newFlightOption = event.target.value;
        setFlightOption(newFlightOption);

        if (newFlightOption === t("noTicket")) {
            setFormValues(prev => ({
                ...prev,
                preferred_flight_class_list: [],
            }));
            setValue("preferred_flight_class_list", []);
        }
    };

    const handleResidencyOptionChange = event => {
        const newResidencyOption = event.target.value;
        setResidencyOption(newResidencyOption);
        if (newResidencyOption === t("noHotel") || newResidencyOption === t("otherAccomodation")) {
            setFormValues(prev => ({
                ...prev,
                preferred_hotel_star_list: [],
            }));
            setValue("preferred_hotel_star_list", []);
        }

        // Update React Hook Form state
        setValue("residencyOption", newResidencyOption);

        setFormValues(prev => {
            const preferHotel = newResidencyOption === t("hotel");
            const newValues = {
                ...prev,
                prefer_hotel: preferHotel,
                preferred_hotel_star_list: preferHotel ? prev.preferred_hotel_star_list : [],
            };

            // Update React Hook Form state
            setValue("prefer_hotel", preferHotel);
            setValue("preferred_hotel_star_list", newValues.preferred_hotel_star_list);

            return newValues;
        });
    };

    // Styled Radio component
    const GreenRadio = styled(Radio)(({ theme }) => ({
        color: theme.palette.success.main,
        "&.Mui-checked": {
            color: theme.palette.success.main,
        },
        "&:hover": {
            backgroundColor: theme.palette.success.light + "20", // Light green background on hover with 20% opacity
        },
    }));

    // Styled FormControlLabel
    const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
        "& .MuiFormControlLabel-label": {
            "&.Mui-focused": {
                color: theme.palette.success.main,
            },
        },
    }));
    // Function to render each step's content
    const getStepContent = stepIndex => {
        return (
            <AnimatePresence mode="popLayout">
                <motion.div
                    key={stepIndex}
                    initial="initial"
                    animate="in"
                    exit="out"
                    variants={activeStep > prevActiveStep ? pageVariantsForward : pageVariantsBackward}
                    transition={pageTransition}
                    style={{
                        position: "absolute",
                        width: "100%",
                    }}
                >
                    <Box sx={{ padding: 2 }}>
                        {(() => {
                            switch (stepIndex) {
                                case 0:
                                    return (
                                        <Box className="step-content">
                                            <Dialog open={showHistory} onClose={handleCloseRequestHistoryModal} fullWidth maxWidth="md">
                                                <DialogContent sx={{ paddingTop: 4 }}>
                                                    <MedicalRequestHistory handleNewRequest={handleNewRequest} accessToken={accessToken} />
                                                </DialogContent>
                                                <DialogActions
                                                    sx={{
                                                        position: "absolute",
                                                        top: 0,
                                                        left: 8,
                                                        padding: 0,
                                                    }}
                                                >
                                                    <IconButton onClick={handleCloseRequestHistoryModal} color="primary" aria-label="close">
                                                        <CloseSquare color="#000000" />
                                                    </IconButton>
                                                </DialogActions>
                                            </Dialog>
                                            <Button
                                                variant="text"
                                                color="success"
                                                onClick={() => {
                                                    setShowHistory(prev => !prev);
                                                }}
                                                sx={{
                                                    padding: "10px 20px",
                                                    fontSize: "16px",
                                                    borderRadius: "8px",
                                                }}
                                                startIcon={<DocumentPrevious />}
                                            >
                                                {t("requestHistory")}
                                            </Button>
                                            <form onSubmit={e => e.preventDefault()}>
                                                <Controller
                                                    name="first_name"
                                                    control={control}
                                                    rules={{ required: t("firstNameRequired") }}
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            label={t("firstName")}
                                                            variant="outlined"
                                                            fullWidth
                                                            required
                                                            error={!!errors.first_name}
                                                            helperText={errors.first_name?.message}
                                                            className="form-element"
                                                            sx={{
                                                                "& .MuiOutlinedInput-root": {
                                                                    "&.Mui-focused fieldset": {
                                                                        borderColor: "#006363",
                                                                    },
                                                                },
                                                            }}
                                                            onChange={e => {
                                                                field.onChange(e);
                                                                setFormValues(prev => ({ ...prev, first_name: e.target.value }));
                                                                trigger("first_name");
                                                            }}
                                                        />
                                                    )}
                                                />
                                                <Controller
                                                    name="last_name"
                                                    control={control}
                                                    rules={{ required: t("lastNameRequired") }}
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            label={t("lastName")}
                                                            variant="outlined"
                                                            fullWidth
                                                            required
                                                            error={!!errors.last_name}
                                                            helperText={errors.last_name?.message}
                                                            className="form-element"
                                                            sx={{
                                                                "& .MuiOutlinedInput-root": {
                                                                    "&.Mui-focused fieldset": {
                                                                        borderColor: "#006363",
                                                                    },
                                                                },
                                                            }}
                                                            onChange={e => {
                                                                field.onChange(e);
                                                                setFormValues(prev => ({ ...prev, last_name: e.target.value }));
                                                                trigger("last_name");
                                                            }}
                                                        />
                                                    )}
                                                />
                                                <Controller
                                                    name="age"
                                                    control={control}
                                                    rules={{
                                                        required: t("ageRequired"),
                                                        pattern: {
                                                            value: /^[0-9]+$/,
                                                            message: t("justNumbers"),
                                                        },
                                                    }}
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            label={t("age")}
                                                            variant="outlined"
                                                            type="number"
                                                            fullWidth
                                                            required
                                                            error={!!errors.age}
                                                            helperText={errors.age?.message}
                                                            className="form-element"
                                                            sx={{
                                                                "& .MuiOutlinedInput-root": {
                                                                    "&.Mui-focused fieldset": {
                                                                        borderColor: "#006363",
                                                                    },
                                                                },
                                                            }}
                                                            onChange={e => {
                                                                field.onChange(e);
                                                                setFormValues(prev => ({ ...prev, age: e.target.value }));
                                                                trigger("age");
                                                            }}
                                                        />
                                                    )}
                                                />
                                                <Controller
                                                    name="gender"
                                                    control={control}
                                                    rules={{ required: t("genderRequired") }}
                                                    render={({ field }) => (
                                                        <FormControl
                                                            fullWidth
                                                            error={!!errors.gender}
                                                            className="form-element"
                                                            required
                                                            sx={{
                                                                "& .MuiOutlinedInput-root": {
                                                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                                        borderColor: "#006363",
                                                                    },
                                                                },
                                                                "& .MuiInputLabel-root.Mui-focused": {
                                                                    color: "#006363",
                                                                },
                                                                "& .MuiSelect-icon": {
                                                                    color: "#006363",
                                                                },
                                                            }}
                                                        >
                                                            <InputLabel>{t("gender")}</InputLabel>
                                                            <Select
                                                                {...field}
                                                                label={t("gender")}
                                                                onChange={e => {
                                                                    field.onChange(e);
                                                                    setFormValues(prev => ({ ...prev, gender: e.target.value }));
                                                                    trigger("gender");
                                                                }}
                                                            >
                                                                <MenuItem value="مرد">{t("male")}</MenuItem>
                                                                <MenuItem value="زن">{t("female")}</MenuItem>
                                                                <MenuItem value="نامشخص">{t("notSpecified")}</MenuItem>
                                                            </Select>
                                                            {errors.gender && <FormHelperText>{errors.gender.message}</FormHelperText>}
                                                        </FormControl>
                                                    )}
                                                />
                                                <Controller
                                                    name="origin_country_id"
                                                    control={control}
                                                    rules={{ required: t("countryRequired") }}
                                                    render={({ field }) => (
                                                        <FormControl
                                                            fullWidth
                                                            required
                                                            error={!!errors.origin_country_id}
                                                            className="form-element"
                                                            sx={{
                                                                "& .MuiOutlinedInput-root": {
                                                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                                        borderColor: "#006363",
                                                                    },
                                                                },
                                                                "& .MuiInputLabel-root.Mui-focused": {
                                                                    color: "#006363",
                                                                },
                                                                "& .MuiSelect-icon": {
                                                                    color: "#006363",
                                                                },
                                                            }}
                                                            onChange={e => {
                                                                field.onChange(e);
                                                                setFormValues(prev => ({ ...prev, origin_country_id: e.target.value }));
                                                            }}
                                                        >
                                                            <InputLabel> {t("departureCountry")} </InputLabel>
                                                            <Select {...field} label={t("departureCountry")}>
                                                                {countries.map(country => (
                                                                    <MenuItem key={country.id} value={country.id}>
                                                                        {locale === "en" ? country.english_name : country.name}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                            {errors.origin_country_id && (
                                                                <FormHelperText>{errors.origin_country_id.message}</FormHelperText>
                                                            )}
                                                        </FormControl>
                                                    )}
                                                />
                                            </form>
                                        </Box>
                                    );
                                case 1:
                                    return (
                                        <Box className="step-content">
                                            <form onSubmit={e => e.preventDefault()}>
                                                <Controller
                                                    name="services"
                                                    control={control}
                                                    required
                                                    rules={{ validate: value => value.length > 0 || t("atLeastOneServiceRequired") }}
                                                    render={({ field }) => (
                                                        <FormGroup className="form-element">
                                                            <div
                                                                style={{
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    alignItems: "center",
                                                                    gap: "1rem",
                                                                }}
                                                            >
                                                                <Typography>{t("selectMedicalServices")}</Typography>
                                                                <span>*</span>
                                                            </div>

                                                            <Grid container spacing={1}>
                                                                {[
                                                                    "psychiatry",
                                                                    "skinAndHair",
                                                                    "beauty",
                                                                    "fertility",
                                                                    "cancer",
                                                                    "dental",
                                                                    "cardiology",
                                                                    "orthopedics",
                                                                    "eyeCare",
                                                                    "digestiveCare",
                                                                ].map(option => (
                                                                    <Grid
                                                                        item
                                                                        xs={6} // Adjust number of columns for xs, sm, md breakpoints
                                                                        sm={4}
                                                                        md={3}
                                                                        key={option}
                                                                        style={{ display: "flex", justifyContent: "center" }} // Center the button in the grid item
                                                                    >
                                                                        <Button
                                                                            variant={field.value.includes(option) ? "contained" : "outlined"}
                                                                            onClick={() => {
                                                                                const updatedServices = field.value.includes(option)
                                                                                    ? field.value.filter(service => service !== option)
                                                                                    : [...field.value, option];
                                                                                field.onChange(updatedServices);
                                                                                setFormValues(prev => ({ ...prev, services: updatedServices }));
                                                                            }}
                                                                            sx={{
                                                                                fontSize: "12px",
                                                                                width: "auto", // Automatically adjust width to fit the content
                                                                                minWidth: "80px", // Ensure a minimum width for shorter text
                                                                                borderRadius: "15px",
                                                                                padding: "6px 10px",
                                                                                textAlign: "center",
                                                                                whiteSpace: "nowrap",
                                                                            }}
                                                                            color="success"
                                                                        >
                                                                            {t(option)}
                                                                        </Button>
                                                                    </Grid>
                                                                ))}
                                                            </Grid>
                                                            {errors.services && <FormHelperText error>{errors.services.message}</FormHelperText>}
                                                        </FormGroup>
                                                    )}
                                                />
                                                <Controller
                                                    name="illness_description"
                                                    control={control}
                                                    rules={{ required: t("illnessDescriptionRequired") }}
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            label={t("illnessDescription")}
                                                            required
                                                            variant="outlined"
                                                            multiline
                                                            rows={4}
                                                            fullWidth
                                                            error={!!errors.illness_description}
                                                            helperText={errors.illness_description?.message}
                                                            className="form-element"
                                                            sx={{
                                                                "& .MuiOutlinedInput-root": {
                                                                    "&.Mui-focused fieldset": {
                                                                        borderColor: "#006363",
                                                                    },
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                />

                                                <FormControl required fullWidth className="form-element">
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                            gap: "1rem",
                                                        }}
                                                    >
                                                        <Typography>{t("selectApproximateTripTime")}</Typography>
                                                        <span>*</span>
                                                    </div>

                                                    <Controller
                                                        name="estimated_trip_time"
                                                        control={control}
                                                        rules={{ required: t("approximateTripTimeRequired") }}
                                                        render={({ field }) => (
                                                            <RadioGroup {...field}>
                                                                <Grid container spacing={1}>
                                                                    {[
                                                                        { value: "1-3months", label: t("1-3months") },
                                                                        { value: "3-6months", label: t("3-6months") },
                                                                        { value: "moreThan6months", label: t("moreThan6months") },
                                                                    ].map(option => (
                                                                        <Grid
                                                                            item
                                                                            xs={12} // Full width on xs
                                                                            sm={4} // 3 columns evenly on small screens and larger
                                                                            key={option.value}
                                                                            style={{ display: "flex", justifyContent: "center" }} // Centering the content
                                                                        >
                                                                            <StyledFormControlLabel
                                                                                value={option.value}
                                                                                control={<GreenRadio />}
                                                                                label={option.label}
                                                                                sx={{
                                                                                    width: "100%", // Full width within the grid item
                                                                                    maxWidth: "150px", // Ensure consistency in label width
                                                                                    textAlign: "center", // Center label text
                                                                                    "& .MuiTypography-root": {
                                                                                        fontSize: {
                                                                                            xs: "0.75rem", // Smaller font size for extra-small screens
                                                                                            sm: "0.875rem", // Slightly larger for small screens
                                                                                        },
                                                                                    },
                                                                                }}
                                                                            />
                                                                        </Grid>
                                                                    ))}
                                                                </Grid>
                                                            </RadioGroup>
                                                        )}
                                                    />
                                                    {errors.estimated_trip_time && (
                                                        <FormHelperText error>{errors.estimated_trip_time.message}</FormHelperText>
                                                    )}
                                                </FormControl>

                                                <Controller
                                                    name="destination_city_id"
                                                    control={control}
                                                    rules={{ required: t("citySelectionRequired") }}
                                                    render={({ field }) => (
                                                        <FormControl
                                                            required
                                                            fullWidth
                                                            error={!!errors.destination_city_id}
                                                            className="form-element"
                                                            sx={{
                                                                "& .MuiOutlinedInput-root": {
                                                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                                        borderColor: "#006363",
                                                                    },
                                                                },
                                                                "& .MuiInputLabel-root.Mui-focused": {
                                                                    color: "#006363",
                                                                },
                                                                "& .MuiSelect-icon": {
                                                                    color: "#006363",
                                                                },
                                                            }}
                                                        >
                                                            <InputLabel>{t("city")}</InputLabel>
                                                            <Select {...field} label={t("chooseCity")}>
                                                                {cities.map(city => (
                                                                    <MenuItem key={city.id} value={city.id}>
                                                                        {locale === "en" ? city.english_name : city.name}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                            {errors.destination_city_id && (
                                                                <FormHelperText>{errors.destination_city_id.message}</FormHelperText>
                                                            )}
                                                        </FormControl>
                                                    )}
                                                />

                                                <Button variant="contained" color="success" component="label" className="form-element">
                                                    {t("uploadFileOptional")}
                                                    <input hidden type="file" multiple onChange={e => handleInputChange("files", e.target.files)} />
                                                </Button>

                                                {formValues.files && formValues.files.length > 0 && (
                                                    <Box sx={{ mt: 2, borderRadius: 1, boxShadow: 1 }}>
                                                        <List dense>
                                                            {formValues.files.map((file, index) => (
                                                                <ListItem
                                                                    key={index}
                                                                    sx={{
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                        alignItems: "center",
                                                                    }}
                                                                >
                                                                    <Box sx={{ display: "flex", alignItems: "center" }}>
                                                                        <ListItemIcon>{getFileIcon(file.name)}</ListItemIcon>
                                                                        <ListItemText
                                                                            primary={file.name}
                                                                            secondary={`${(file.size / 1024 / 1024).toFixed(2)} MB`}
                                                                        />
                                                                    </Box>
                                                                    <IconButton
                                                                        onClick={() => handleRemoveFile(index)}
                                                                        color="error"
                                                                        aria-label="remove file"
                                                                    >
                                                                        <CloseSquare size={20} />
                                                                    </IconButton>
                                                                </ListItem>
                                                            ))}
                                                        </List>
                                                    </Box>
                                                )}
                                            </form>
                                        </Box>
                                    );
                                case 2:
                                    return (
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: 4,
                                                p: 2,
                                                maxWidth: "100%",
                                                width: { xs: "100%", sm: 600, md: 800 },
                                                margin: "auto",
                                                borderRadius: 2,
                                            }}
                                        >
                                            <MotionBox
                                                sx={{ bgcolor: "white", p: 3, borderRadius: 2 }}
                                                initial={{ opacity: 0, y: -20 }}
                                                animate={{ opacity: 1, y: 0 }}
                                                transition={{ duration: 0.1 }}
                                            >
                                                <Typography variant="h5" gutterBottom>
                                                    {t("flightInformation")}
                                                </Typography>
                                                <FormControl
                                                    component="fieldset"
                                                    sx={{
                                                        "&.Mui-focused": {
                                                            color: "#006363",
                                                        },
                                                        fontSize: 16,
                                                    }}
                                                >
                                                    <FormLabel
                                                        component="legend"
                                                        sx={{
                                                            "&.Mui-focused": {
                                                                color: "#006363",
                                                            },
                                                            fontSize: 16,
                                                        }}
                                                    >
                                                        {t("ticketType")}
                                                    </FormLabel>
                                                    <RadioGroup
                                                        value={flightOption}
                                                        onChange={handleFlightOptionChange}
                                                        sx={{
                                                            flexDirection: "row",
                                                            columnGap: "1rem",
                                                            width: "100%",
                                                            mt: 1,
                                                        }}
                                                    >
                                                        <StyledFormControlLabel value={t("flight")} control={<GreenRadio />} label={t("flight")} />
                                                        <StyledFormControlLabel
                                                            value={t("noTicket")}
                                                            control={<GreenRadio />}
                                                            label={t("noTicket")}
                                                        />
                                                    </RadioGroup>
                                                </FormControl>
                                                {flightOption === t("flight") && (
                                                    <MotionBox
                                                        sx={{ mt: 3 }}
                                                        initial={{ opacity: 0, height: 0 }}
                                                        animate={{ opacity: 1, height: "auto" }}
                                                        transition={{ duration: 0.1 }}
                                                    >
                                                        <Grid container spacing={2}>
                                                            {[t("business"), t("economy")].map(option => (
                                                                <Grid item xs={6} sm={4} md={3} key={option}>
                                                                    <Button
                                                                        variant={
                                                                            formValues.preferred_flight_class_list.includes(option)
                                                                                ? "contained"
                                                                                : "outlined"
                                                                        }
                                                                        onClick={() => handlePreferedFlightClassListCheckboxChange(option)}
                                                                        sx={{
                                                                            borderRadius: "15px",
                                                                            padding: "8px 16px",
                                                                            width: "100%",
                                                                            textAlign: "center",
                                                                        }}
                                                                        color="success"
                                                                    >
                                                                        {t(option)}
                                                                    </Button>
                                                                </Grid>
                                                            ))}
                                                        </Grid>
                                                    </MotionBox>
                                                )}
                                            </MotionBox>

                                            <MotionBox
                                                sx={{ bgcolor: "white", p: 3, borderRadius: 2 }}
                                                initial={{ opacity: 0, y: -20 }}
                                                animate={{ opacity: 1, y: 0 }}
                                                transition={{ duration: 0.1 }}
                                            >
                                                <Typography variant="h5" gutterBottom>
                                                    {t("accommodationInformation")}
                                                </Typography>
                                                <FormControl component="fieldset">
                                                    <FormLabel
                                                        component="legend"
                                                        sx={{
                                                            "&.Mui-focused": {
                                                                color: "#006363",
                                                            },
                                                            fontSize: 16,
                                                        }}
                                                    >
                                                        {t("accommodationType")}
                                                    </FormLabel>
                                                    <RadioGroup
                                                        value={residencyOption}
                                                        onChange={handleResidencyOptionChange}
                                                        sx={{
                                                            flexDirection: "row",
                                                            columnGap: "1rem",
                                                            width: "100%",
                                                        }}
                                                    >
                                                        <StyledFormControlLabel value={t("hotel")} control={<GreenRadio />} label={t("hotel")} />
                                                        <StyledFormControlLabel
                                                            value={t("otherAccommodation")}
                                                            control={<GreenRadio />}
                                                            label={t("otherAccommodation")}
                                                        />
                                                        <StyledFormControlLabel value={t("noHotel")} control={<GreenRadio />} label={t("noHotel")} />
                                                    </RadioGroup>
                                                </FormControl>
                                                {residencyOption === t("hotel") && (
                                                    <MotionBox
                                                        sx={{ mt: 3 }}
                                                        initial={{ opacity: 0, height: 0 }}
                                                        animate={{ opacity: 1, height: "auto" }}
                                                        transition={{ duration: 0.1 }}
                                                    >
                                                        <Grid container spacing={2}>
                                                            {[t("threeStars"), t("fourStars"), t("fiveStars")].map(option => (
                                                                <Grid item xs={6} sm={4} md={3} key={option}>
                                                                    <Button
                                                                        variant={
                                                                            formValues.preferred_hotel_star_list.includes(option)
                                                                                ? "contained"
                                                                                : "outlined"
                                                                        }
                                                                        onClick={() => handlePreferedHotelStarListCheckboxChange(option)}
                                                                        sx={{
                                                                            borderRadius: "15px",
                                                                            padding: "8px 16px",
                                                                            width: "100%",
                                                                            textAlign: "center",
                                                                        }}
                                                                        color="success"
                                                                    >
                                                                        {option}
                                                                    </Button>
                                                                </Grid>
                                                            ))}
                                                        </Grid>
                                                    </MotionBox>
                                                )}
                                            </MotionBox>
                                            <Typography variant="h5" gutterBottom>
                                                {t("travelServices")}
                                            </Typography>
                                            <FormControl component="fieldset" variant="standard">
                                                <FormLabel
                                                    component="legend"
                                                    sx={{
                                                        "&.Mui-focused": {
                                                            color: "#006363",
                                                        },
                                                        fontSize: 16,
                                                    }}
                                                >
                                                    {t("pleaseSpecifyTravelServices")}
                                                </FormLabel>
                                                <FormControl component="fieldset" variant="standard">
                                                    <Grid container spacing={2} sx={{ mt: 1 }}>
                                                        {[
                                                            { name: "preferred_with_breakfast", label: t("breakfast") },
                                                            { name: "preferred_with_lunch", label: t("lunch") },
                                                            { name: "preferred_with_dinner", label: t("dinner") },
                                                            { name: "preferred_with_airport_transfer", label: t("transfer") },
                                                        ].map(option => (
                                                            <Grid item xs={6} sm={3} key={option.name}>
                                                                <Controller
                                                                    name={option.name}
                                                                    control={control}
                                                                    defaultValue={false}
                                                                    render={({ field }) => (
                                                                        <Button
                                                                            variant={field.value ? "contained" : "outlined"}
                                                                            onClick={() => field.onChange(!field.value)}
                                                                            sx={{
                                                                                borderRadius: "15px",
                                                                                padding: "8px 16px",
                                                                                width: "100%",
                                                                                textAlign: "center",
                                                                            }}
                                                                            color="success"
                                                                        >
                                                                            {option.label}
                                                                        </Button>
                                                                    )}
                                                                />
                                                            </Grid>
                                                        ))}
                                                    </Grid>
                                                </FormControl>
                                            </FormControl>
                                        </Box>
                                    );
                                case 3:
                                    return (
                                        <Box className="step-content">
                                            <form onSubmit={e => e.preventDefault()}>
                                                <Controller
                                                    name="mobile_phone"
                                                    control={control}
                                                    rules={{
                                                        required: t("phoneRequired"),
                                                        pattern: {
                                                            value: /^(09|\u06F0\u06F9)[0-9\u06F0-\u06F9]{9}$/,
                                                            message: `${t("phoneNumber")} ${t("isWrong")}`,
                                                        },
                                                    }}
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            required
                                                            type="number"
                                                            label={t("phone")}
                                                            variant="outlined"
                                                            fullWidth
                                                            error={!!errors.mobile_phone}
                                                            helperText={errors.mobile_phone?.message}
                                                            className="form-element"
                                                            sx={{
                                                                "& .MuiOutlinedInput-root": {
                                                                    "&.Mui-focused fieldset": {
                                                                        borderColor: "#006363",
                                                                    },
                                                                },
                                                            }}
                                                            onChange={e => {
                                                                field.onChange(e);
                                                                setFormValues(prev => ({ ...prev, mobile_phone: e.target.value }));
                                                            }}
                                                        />
                                                    )}
                                                />

                                                <Controller
                                                    name="email"
                                                    control={control}
                                                    rules={{
                                                        pattern: {
                                                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                            message: t("emailNotValid"),
                                                        },
                                                    }}
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            label={t("email")}
                                                            variant="outlined"
                                                            fullWidth
                                                            error={!!errors.email}
                                                            helperText={errors.email?.message}
                                                            className="form-element"
                                                            sx={{
                                                                "& .MuiOutlinedInput-root": {
                                                                    "&.Mui-focused fieldset": {
                                                                        borderColor: "#006363",
                                                                    },
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                />

                                                <Controller
                                                    name="telegram"
                                                    control={control}
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            label={t("telegram")}
                                                            variant="outlined"
                                                            fullWidth
                                                            className="form-element"
                                                            sx={{
                                                                "& .MuiOutlinedInput-root": {
                                                                    "&.Mui-focused fieldset": {
                                                                        borderColor: "#006363",
                                                                    },
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                />

                                                <Controller
                                                    name="facebook"
                                                    control={control}
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            label={t("facebook")}
                                                            variant="outlined"
                                                            fullWidth
                                                            className="form-element"
                                                            sx={{
                                                                "& .MuiOutlinedInput-root": {
                                                                    "&.Mui-focused fieldset": {
                                                                        borderColor: "#006363",
                                                                    },
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                />

                                                <Controller
                                                    name="whatsapp"
                                                    control={control}
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            label={t("whatsapp")}
                                                            variant="outlined"
                                                            fullWidth
                                                            className="form-element"
                                                            sx={{
                                                                "& .MuiOutlinedInput-root": {
                                                                    "&.Mui-focused fieldset": {
                                                                        borderColor: "#006363",
                                                                    },
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </form>
                                        </Box>
                                    );
                                case 4:
                                    return (
                                        <Card
                                            sx={{
                                                width: "100%",
                                                maxWidth: isSmallScreen ? "100%" : "600px",
                                                textAlign: "center",
                                            }}
                                        >
                                            {showHistory ? (
                                                <MedicalRequestHistory handleNewRequest={handleNewRequest} accessToken={accessToken} />
                                            ) : (
                                                <CardContent>
                                                    <TickCircle variant="Bold" size={48} color="#4caf50" />
                                                    <Typography variant="h6" sx={{ marginTop: 2, color: "#4caf50" }}>
                                                        {t("requestSubmittedSuccessfully")}
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ marginTop: 1 }}>
                                                        {t("willContactSoon")}
                                                    </Typography>
                                                    <Grid
                                                        container
                                                        spacing={2}
                                                        justifyContent="center"
                                                        alignItems="center"
                                                        style={{ marginTop: "20px" }}
                                                    >
                                                        <Grid item>
                                                            <Button
                                                                variant="contained"
                                                                color="success"
                                                                onClick={() => setShowHistory(prev => !prev)}
                                                                style={{ padding: "10px 20px", fontSize: "16px" }}
                                                            >
                                                                {t("trackRequest")}
                                                            </Button>
                                                        </Grid>
                                                        <Grid item>
                                                            <Button
                                                                variant="outlined"
                                                                color="success"
                                                                onClick={handleNewRequest}
                                                                style={{ padding: "10px 20px", fontSize: "16px" }}
                                                            >
                                                                {t("newRequest")}
                                                            </Button>
                                                        </Grid>
                                                    </Grid>
                                                </CardContent>
                                            )}
                                        </Card>
                                    );
                                default:
                                    return t("unknownStep");
                            }
                        })()}
                    </Box>
                </motion.div>
            </AnimatePresence>
        );
    };

    // Disable the "Next" button if the current form is not filled
    const isNextDisabled = () => {
        if (activeStep === 0) {
            const { first_name, last_name, gender, age, origin_country_id } = getValues();
            return !(
                first_name &&
                last_name &&
                gender &&
                age &&
                origin_country_id &&
                first_name.trim() !== "" &&
                last_name.trim() !== "" &&
                age.toString().trim() !== "" &&
                origin_country_id.toString().trim() !== ""
            );
        }
        if (activeStep === 1) {
            return !isValid || !isStepValid();
        }
        if (activeStep === 2) {
            // Check flight options
            const flightValid = flightOption === t("noTicket") || formValues.preferred_flight_class_list.length > 0;

            // Check residency options
            const residencyValid =
                residencyOption === t("noHotel") ||
                residencyOption === t("otherAccommodation") ||
                (residencyOption === t("hotel") && formValues.preferred_hotel_star_list.length > 0);

            return !(flightValid && residencyValid);
        }
        if (activeStep === 3) {
            const mobilePhone = getValues("mobile_phone");
            return !mobilePhone || mobilePhone.trim() === "";
        }
        return false;
    };

    const handleNewRequest = () => {
        // Reset form values
        setFormValues({
            first_name: "",
            last_name: "",
            gender: "",
            age: "",
            origin_country_id: "",
            services: [],
            illness_description: "",
            estimated_trip_time: "",
            destination_city_id: "",
            files: [],
            prefer_residence: false,
            prefer_hotel: false,
            preferred_hotel_star_list: [],
            preferred_flight_class_list: [],
            mobile_phone: "",
            email: "",
            telegram: "",
            facebook: "",
            whatsapp: "",
        });

        // Reset other state variables
        setFlightOption(t("flight"));
        setResidencyOption(t("hotel"));
        setTripPreferences({
            preferred_with_breakfast: false,
            preferred_with_dinner: false,
            preferred_with_lunch: false,
            preferred_with_airport_transfer: false,
        });
        // Reset React Hook Form state
        reset({
            first_name: "",
            last_name: "",
            gender: "",
            age: "",
            origin_country_id: "",
            services: [],
            illness_description: "",
            estimated_trip_time: "",
            destination_city_id: "",
            flightOption: t("flight"),
            residencyOption: t("hotel"),
            preferred_hotel_star_list: [],
            preferred_flight_class_list: [],
            preferred_with_breakfast: false,
            preferred_with_dinner: false,
            preferred_with_lunch: false,
            preferred_with_airport_transfer: false,
            mobile_phone: "",
            email: "",
            telegram: "",
            facebook: "",
            whatsapp: "",
        });

        // Reset the active step
        setActiveStep(0);
    };

    const allFields = watch(); // Watch all form fields

    useEffect(() => {
        // This ensures that when fields change, the form revalidates
        if (isValid) {
            // Perform any additional logic if needed
        }
    }, [allFields, isValid]);

    return (
        <Box
            className="multi-step-form-container"
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "100vh",
                padding: isSmallScreen ? "10px" : "20px", // Responsive padding
                // marginTop: 1,
            }}
        >
            {/* <LoginModal open={openLogin} setOpen={setOpenLogin} /> */}
            <Card
                sx={{
                    width: "100%",
                    maxWidth: isSmallScreen ? "100%" : "600px",
                    boxShadow: 3,
                    borderRadius: "10px",
                }}
            >
                <CardContent
                    sx={{
                        // padding: isSmallScreen ? "10px" : "20px 40px",
                        height: "700px", // Adjust this value to accommodate the fixed height container and other elements
                        display: "flex",
                        flexDirection: "column",
                        // marginX: "0px",
                        // width: isSmallScreen ? "20rem" : "100%",
                    }}
                >
                    <Box sx={{ width: "100%", overflowX: "auto" }}>
                        <Stepper activeStep={activeStep} alternativeLabel className="stepper-container">
                            {stepKeys.map((key, index) => (
                                <Step key={index}>
                                    <StepLabel
                                        sx={{
                                            "& .MuiStepIcon-root": {
                                                color: activeStep === index ? "green" : "#9e9e9e",
                                            },
                                            "& .MuiStepIcon-completed": {
                                                color: "green",
                                            },
                                            "& .MuiStepLabel-label": {
                                                color: activeStep === index ? "green" : "#9e9e9e",
                                                fontWeight: activeStep === index ? "bold" : "normal",
                                            },
                                        }}
                                    >
                                        {/* {label} */}
                                        <Trans i18nKey={key} />
                                    </StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                    </Box>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        {activeStep !== 0 && (
                            <Button
                                variant="text"
                                color="success"
                                onClick={() => {
                                    handleNewRequest();
                                }}
                                sx={{
                                    padding: "10px 20px",
                                    fontSize: "16px",
                                    borderRadius: "8px",
                                }}
                                startIcon={<AddCircle />}
                            >
                                {t("createNewRequest")}
                            </Button>
                        )}
                    </div>

                    <Box
                        ref={formContentRef}
                        sx={{
                            flexGrow: 1,
                            overflowY: "auto",
                            position: "relative",
                            mt: 1,
                        }}
                    >
                        {getStepContent(activeStep)}
                    </Box>

                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                        {activeStep !== steps.length - 1 && (
                            <Button color="success" disabled={activeStep === 0} onClick={handleBack}>
                                {t("previousStep")}
                            </Button>
                        )}
                        {activeStep < steps.length - 1 && (
                            <Button color="success" variant="contained" onClick={handleNext} disabled={isNextDisabled()}>
                                {activeStep === steps.length - 2 ? t("submitRequest") : t("nextStep")}
                            </Button>
                        )}
                    </Box>
                </CardContent>
            </Card>
        </Box>
    );
};

export default MedicalTourismMultiStepForm;
